// extracted by mini-css-extract-plugin
module.exports = {"container":"BigCommerceAdminBar_container__XIFJC","logo":"BigCommerceAdminBar_logo__B0nDX","info":"BigCommerceAdminBar_info__IbYXA","close":"BigCommerceAdminBar_close__gDqRv"};